import { useState } from "react";
import { Modal } from "react-bootstrap";
import Spinner from "../Components/Spinner";
import ErrorMessage from "../Components/ErrorMessage";
import MandatorySign from "../Components/MandatorySign";
import { useNavigate, useParams } from "react-router-dom";
import { useLanguage } from "../Translations/LenguageContext";

const GEN_BACKEND_LINK = process.env.REACT_APP_GEN_BACKEND_LINK;

const NewFineTuneModal = ({ account_id, show, handleClose, fetchRecords }) => {
    const { t } = useLanguage()
    const navigate = useNavigate()
    const { org_id } = useParams()
    const [loadingSave, setLoadingSave] = useState(false);
    const [errorMessage, setErrorMessage] = useState({ message: "", display: false });

    const [formData, setFormData] = useState({
        name: "",
        description: ""
    });

    const handleChange = (e) => {
        setFormData(prev => ({
            ...prev,
            [e.target.name]: e.target.value
        }));
    };

    const handleSave = async () => {
        if (!formData.name.trim()) {
            setErrorMessage({ message: t.finetune.title_required, display: true });
            return;
        }

        if (!formData.description.trim()) {
            setErrorMessage({ message: t.finetune.desc_required, display: true });
            return;
        }

        setLoadingSave(true);
        setErrorMessage({ message: "", display: false });

        try {
            const response = await fetch(`${GEN_BACKEND_LINK}/create_ft_job`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    account_id,
                    org_id,
                    name: formData.name,
                    description: formData.description
                }),
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.error || "Something went wrong");
            }

            if (data.message == "OK") {
                const ft_id = data.ft_id
                navigate(`/e8console/organizations/${org_id}/fine-tune/${ft_id}`)
            }

            closeModal();
            fetchRecords()
        } catch (error) {
            setErrorMessage({
                message: error.message || "Server error",
                display: true
            });
        } finally {
            setLoadingSave(false);
        }
    };

    const closeModal = () => {
        handleClose();
        setFormData({ name: "", description: "" });
        setErrorMessage({ message: "", display: false });
        setLoadingSave(false);
    };

    return (
        <Modal show={show} centered onHide={closeModal}>
            <div className="modal_header">
                <p className="modal_header_title">{t.finetune.new_title}</p>
            </div>

            <div className="modal_main_cont">
                <div className="modal_profile_input_cont">
                    <div className="label_input">
                        <label className="input_label">{t.title} <MandatorySign message={t.mandatory_field} /></label>
                        <input
                            type="text"
                            name="name"
                            maxLength={100}
                            value={formData.name}
                            onChange={handleChange}
                            placeholder="Ex. Job 1"
                            className="register_form_first fade-in"
                            autoComplete="off"
                        />
                    </div>

                    <div className="label_input">
                        <label className="input_label">
                            {/* Description <span className="optional_input_label">(optional)</span> */}
                            {t.description} <MandatorySign message={t.mandatory_field} />
                        </label>
                        <textarea
                            name="description"
                            maxLength={300}
                            value={formData.description}
                            onChange={handleChange}
                            placeholder="Ex. Model training"
                            className="register_form_first textarea_reg fade-in"
                            autoComplete="off"
                        />
                    </div>
                </div>
            </div>

            <div className="modal_footer">
                <div className="modal_footer_err_cont">
                    <ErrorMessage err={errorMessage} />
                </div>

                <div className="modal_footer_btn_cont">
                    <button
                        className="modale_save_btn"
                        onClick={handleSave}
                        disabled={loadingSave}
                    >
                        {loadingSave ? <Spinner loading={true} /> : t.save}
                    </button>

                    <button
                        className="modale_close_btn"
                        onClick={closeModal}
                        disabled={loadingSave}
                    >
                        {t.close}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default NewFineTuneModal;